import { useTranslation } from "react-i18next";
import { FormikInsurance, FormikContractorLegal } from "src/types";
import { useCompanyTypeOptions } from "../../../../handlers/form-label-mapping.hook";

export const useLegalContractorSummary = ({
  insurance,
}: {
  insurance: FormikInsurance;
}) => {
  const { t } = useTranslation();
  const { companyTypeOptions } = useCompanyTypeOptions();

  const legalContractor = insurance.contractor as FormikContractorLegal;

  const companyTypeLabel =
    companyTypeOptions.find((opt) => opt.id === legalContractor.companyType)
      ?.value || "";

  return { legalContractor, companyTypeLabel, t };
};
